export const GENERIC_BASE_TEMPLATES = [
  { id: 'BLANK', name: 'Blank Template' },
  { id: 'MRC', name: 'MRCv3 Base Template' },
];
